import React from 'react';
import { HeartHandshakeIcon, UsersIcon } from 'lucide-react';
import { BowIcon } from './icons/NailIcons';
export function About() {
  return <section id="sobre-mi" className="w-full bg-cream py-20 sm:py-28" data-id="element-11" data-mp="2prqpouj5yqjh">
      <div className="mx-auto grid w-full max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-[0.85fr_1fr] lg:gap-20" data-id="element-12" data-mp="2ts0qztw0gss0">
        <div className="relative mx-auto w-full max-w-sm lg:max-w-none" data-id="element-13" data-mp="2ytgfjvxedhf5">
          <div className="absolute -left-4 -top-4 hidden h-32 w-32 rounded-[2rem] border border-blush-300 lg:block" data-id="element-14" data-mp="33q6welh10h1m" />
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/00318369-f44c-4291-b3ae-b040906248df.jpg" alt="Camila, nail artist y fundadora de Cami Nails, en su estudio" className="relative aspect-[4/5] w-full rounded-[2.5rem] object-cover shadow-soft" data-id="element-15" data-mp="38orwmkwa30q2" />
        </div>

        <div data-id="element-16" data-mp="3mfwo2zphsmpb">
          <p className="flex items-center gap-2 text-sm font-semibold text-rosegold-dark" data-id="element-17" data-mp="3rgko2avp8dvo">
            <BowIcon className="h-5 w-5" data-id="element-18" data-mp="2lr7ii6i4g62y" />
            Detrás del estudio
          </p>
          <h2 className="mt-4 font-serif text-4xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-19" data-mp="2louqt1mkahcp">
            ¿Quién es Cami?
          </h2>
          <div className="mt-6 space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-20" data-mp="2cpr8w0z4s7zs">
            <p data-id="element-21" data-mp="27rzff2iu8dth">
              Soy Camila, nail artist y fundadora del estudio. Hace más de cinco años que me dedico
              a las uñas y sigo formándome cada año con las técnicas y tendencias que realmente
              cuidan la uña natural.
            </p>
            <p data-id="element-22" data-mp="30i7yqxp4149n">
              Trabajo de a una clienta por turno para dedicarle el tiempo que merece: analizo tu
              uña, elijo la técnica correcta y construyo un diseño pensado para tu mano y tu rutina.
              Nada de apuros ni trabajos en serie.
            </p>
            <p className="font-medium text-ink" data-id="element-23" data-mp="3o794gd6k61b8">
              Mi compromiso es simple: higiene impecable, materiales premium y un resultado que te
              dé ganas de mostrar las manos.
            </p>
          </div>

          <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-24" data-mp="686gawosysuk">
            <div className="flex items-start gap-3 rounded-2xl border border-blush-200 bg-blush-50 p-5" data-id="element-25" data-mp="b3ltdmezkkpx">
              <UsersIcon className="mt-0.5 h-5 w-5 text-fucsia-deep" aria-hidden="true" data-id="element-26" data-mp="3tiehdgicjlse" />
              <div data-id="element-27" data-mp="1dsqrawtnfxt">
                <p className="font-semibold text-ink" data-id="element-28" data-mp="1dapfzvaybj1">1250+ seguidoras</p>
                <p className="mt-0.5 text-sm text-ink-soft" data-id="element-29" data-mp="3jjyrfgv22ikh">
                  Comunidad que confía y vuelve mes a mes
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-2xl border border-blush-200 bg-blush-50 p-5" data-id="element-30" data-mp="3akk4gre3kq4q">
              <HeartHandshakeIcon className="mt-0.5 h-5 w-5 text-fucsia-deep" aria-hidden="true" data-id="element-31" data-mp="3ekvlzvb5yabz" />
              <div data-id="element-32" data-mp="18sfevmk2m4x6">
                <p className="font-semibold text-ink" data-id="element-33" data-mp="18u07h6mtrdse">Especialista premium</p>
                <p className="mt-0.5 text-sm text-ink-soft" data-id="element-34" data-mp="1cuk5sdj4wng4">
                  Formación continua en soft gel y nail art
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}